import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { createApiUrlWithPrefix } from '../config/api';

const SettingsContext = createContext();

export function useSettings() {
  return useContext(SettingsContext);
}

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchSettings = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get(createApiUrlWithPrefix('admin/settings'));
      const map = {};
      res.data.forEach(s => {
        map[s.key] = s.value;
      });
      setSettings(map);
      setError(null);
    } catch (err) {
      console.error('Failed to load settings:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSettings();
  }, [fetchSettings]);

  const getSetting = useCallback((key, defaultValue = null) => {
    return settings[key] !== undefined ? settings[key] : defaultValue;
  }, [settings]);

  const getSettingAsNumber = useCallback((key, defaultValue = 0) => {
    const val = settings[key];
    if (val === undefined || val === null) return defaultValue;
    const num = parseFloat(val);
    return isNaN(num) ? defaultValue : num;
  }, [settings]);

  return (
    <SettingsContext.Provider value={{
      settings,
      loading,
      error,
      getSetting,
      getSettingAsNumber,
      refresh: fetchSettings
    }}>
      {children}
    </SettingsContext.Provider>
  );
}
